import { brand } from '../../theme/themePrimitives';
import BulkMessagesModal from '../lead/modal/bulk_message';
import DeleteleadsModal from '../lead/modal/delete_leads';
import { fetchAutomationThunk } from '../../redux/thunks/automation';
import { getAllPipelinesThunk } from '../../redux/thunks/pipeline';
import { LeadObject } from '../../params/redux/leads';
import PushToPipelineModal from '../lead/modal/select_pipeline_stage';
import RunAutomationModal from '../lead/modal/run_automation';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AddOutlined, DeleteOutline, DynamicFeedOutlined, OpenInFull } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams, GridRowSelectionModel } from '@mui/x-data-grid';
import { fetchClientIntegrationsThunk, fetchIntegrationsThunk } from '../../redux/thunks/integration';
import { settingSelectedLead, settingSelectedLeadFlag } from '../../redux/slices/leads';
import { useDispatch, useSelector } from 'react-redux';

const SubmissionsComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { leads } = useSelector((state: RootState) => state.lead);
    const { selectedForm } = useSelector((state: RootState) => state.form);
    const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [runAutomation, setRunAutomation] = useState<boolean>(false);
    const [bulkMessage, setBulkMessage] = useState<boolean>(false);
    const [deleteLead, setDeleteLead] = useState<boolean>(false);

    const filteredLeads = leads.filter((lead: LeadObject) => lead.form_id === selectedForm?.id);

    const rows: LeadObject[] = filteredLeads.map((lead: LeadObject) => ({
        ...lead
    })) || [];

    const openLeadHandler = (lead: LeadObject) => {
        dispatch(settingSelectedLead(lead));
        dispatch(settingSelectedLeadFlag(true));
    };

    const columns: GridColDef<LeadObject>[] = [
        {
            field: 'id',
            headerName: '',
            renderCell: (params: GridRenderCellParams<LeadObject, number>) => <Box>
                <IconButton onClick={() => openLeadHandler(params.row)}>
                    <OpenInFull />
                </IconButton>
            </Box>
        },
        { field: 'email', headerName: 'EMAIL', flex: 1 },
        { field: 'phone', headerName: 'PHONE', flex: 1 }
    ];

    const InserLeadsToPipelineHandler = async () => {
        try {
            await dispatch(getAllPipelinesThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            setShowModal(true);
        } catch (e) {
            //
        }
    };

    const runAutomationHandler = async () => {
        try {
            await dispatch(fetchAutomationThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            setRunAutomation(true);
        } catch (e) {
            //
        }
    };

    const bulkMessageHandler = async () => {
            try {
                if (id) {
                    await dispatch(fetchClientIntegrationsThunk(parseInt(id as string, 10))).unwrap();
                } else {
                    await dispatch(fetchIntegrationsThunk()).unwrap();
                }
                setBulkMessage(true);
            } catch (e) {
                //
            }
        };

    return <Box minHeight="60vh">
        {selectedRows.length !== 0 && <Box display="flex" justifyContent="end" gap={2}>
            <Button variant="contained" sx={{ display: 'none' }} onClick={runAutomationHandler}>Run Automation</Button>
            <Button variant="contained" startIcon={<AddOutlined />} onClick={InserLeadsToPipelineHandler}>Push to Pipeline</Button>
            <Button variant="contained" startIcon={<DynamicFeedOutlined />} onClick={bulkMessageHandler}>Send Bulk Message</Button>
            <Button variant="outlined" startIcon={<DeleteOutline />} color="error" onClick={() => setDeleteLead(true)}>Delete Selected</Button>
        </Box>}
        <Typography variant="subtitle1" color="textSecondary">No of Forms Submitted - <Typography component="span" variant="subtitle1" color={brand[300]}>{rows.length}</Typography></Typography>
        <Box height="50vh" width="100%" mt={2}>
            <DataGrid
                rows={rows as LeadObject[]}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 20
                        }
                    }
                }}
                rowSelectionModel={selectedRows}
                pageSizeOptions={[5, 10, 20]}
                onRowSelectionModelChange={(newSelection: GridRowSelectionModel) => setSelectedRows(newSelection)}
                checkboxSelection
                sx={{
                    '& .MuiDataGrid-row--borderBottom': {
                        backgroundColor: `${brand[50]} !important`
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 'bold'
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        fontWeight: 'bold'
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: '14px'
                    },
                    'width': '100%',
                    'overflowX': 'hidden'
                }}
            />
        </Box>
        <PushToPipelineModal selectedRows={selectedRows as number[]} open={showModal} onClose={() => setShowModal(false)} />
        <RunAutomationModal selectedRows={selectedRows as number[]} open={runAutomation} onClose={() => setRunAutomation(false)} />
        <DeleteleadsModal selectedRows={selectedRows as number[]} open={deleteLead} onClose={() => setDeleteLead(false)} />
        <BulkMessagesModal selectedRows={selectedRows as number[]} open={bulkMessage} onClose={() => setBulkMessage(false)} />
    </Box>;
};

export default SubmissionsComponent;